import React from "react";
import { useSelector } from "react-redux";

function ClaimStepProgress() {
  // get step from redux
  const step = useSelector((state) => state.user.step) ?? 0; // fallback to 0
  const totalSteps = 3; // adjust if you have more/less steps

  return (
    <div className="w-full flex justify-center pb-4 ">
      <div className="flex gap-3 w-full">
        {[...Array(totalSteps)].map((_, index) => {
          const isActive = index < step;
          return (
            <div
              key={index}
              className={`h-2 flex flex-1 w-full rounded-sm transition-colors ${
                isActive ? "bg-[#494A4C]" : "bg-[#D9D9D9]"
              }`}
            />
          );
        })}
      </div>
    </div>
  );
}

export default ClaimStepProgress;
